export const p_canImportStock = "vt_import_stock"
export const p_canUpdateSupplierGroups = "vt_web_change_supplier_groups"
export const p_canUpdateSupplierCompanies = "vt_web_change_supplier_companies"

export const AppPermissions = {
  canImportStock: p_canImportStock,
  canUpdateSupplierGroups: p_canUpdateSupplierGroups,
  canUpdateSupplierCompanies: p_canUpdateSupplierCompanies,
  canByPassUniqueIdValidation: "vt_bypass_unique_id_validation",
  canViewDock: "ds_view_dock",
  canConsolidateDemand: "ds_consolidate_demand",
  canEditQuality: "ds_edit_quality",
  canEditQualityCriteria: "ds_edit_qc_criteria",
  canDeleteInwards: "ds_delete_inward_new",
  canEditAlternateSupplierNumber: "vt_web_change_supplier_alternate_number",
  // canUpdateSupplierDetails: "vt_can_change_supplier_details",
  // canUpdateVendorDetails: "vt_can_change_vendor_details",
  // canUpdateVehicleOwnerDetails: "vt_can_change_vehicle_owner_details",
}
